import PlaylistItem from '../../models/playlistItem/playlistItem';
import Source from '../../models/source';
import Track from '../../models/track/track';

/**
 * What the library shortcuts do with a selection, kept apart from the hook
 * that wires them so it can be tested without a playlist view.
 */

/**
 * The track Enter plays: the one selected last, if it is still selected -
 * that is the row the user just clicked - and otherwise the first selected
 * one in the order shown. Undefined with nothing selected.
 */
export function trackToPlay<T>(
  lastSelected: T | undefined,
  selected: ReadonlySet<T>,
  visible: readonly T[],
) {
  if (lastSelected !== undefined && selected.has(lastSelected)) {
    return lastSelected;
  }

  return visible.find((x) => selected.has(x));
}

/**
 * The selection as library records, for the editor. A row can be a playlist
 * item or a track a streaming search turned up; either way only what the
 * library knows can be edited, and the rest is dropped.
 */
export function libraryTracksOf(
  selected: Iterable<PlaylistItem | Track>,
  getLibraryTrack: (item: PlaylistItem) => Track,
) {
  return [...selected]
    .map((x) =>
      (x as PlaylistItem).trackType !== undefined
        ? getLibraryTrack(x as PlaylistItem)
        : getLibraryTrack(PlaylistItem.from(x as Track)),
    )
    .filter((x) => x.type !== Source.Null);
}
